module.exports = __webpack_public_path__ + "static/media/tatu_logo1.ebf865dd.png";